// @flow
import * as React from 'react';
import styled from 'styled-components';
import { SecondaryButton } from 'components/Button';
import { colors, mediaRetina } from '../theme';

const SaveButton = styled(({ saved, ...props }: { saved: boolean }) => (
  <SecondaryButton {...props}>
    {saved ? getText('Unsave') : getText('Save')}
  </SecondaryButton>
))`
  background-image: ${props =>
    props.saved
      ? "url('/static/images/icons/heart-solid-green.svg')"
      : "url('/static/images/icons/heart-outline-grey.svg')"};
  background-repeat: no-repeat;
  background-position: 16px;
  background-size: 17px 15px;
  padding-left: 38px;
  &:hover {
    color: ${colors.battleshipGrey};
    box-shadow: inset 0 0 0 1px ${colors.battleshipGrey};
    &:not(:disabled) {
      background-image: url('/static/images/icons/heart-solid-green.svg');
    }
  }
  @media ${mediaRetina} {
    &:hover {
      box-shadow: inset 0 0 0 1.5px ${colors.battleshipGrey};
    }
  }
`;

export default SaveButton;
